export const draftCombineUrl = "/draftcombineapi";
// export const authConfig = {
//   token: "test123",
//   username: "Basketball1",
//   password: "Basketball1",
// };

export const isShowUnitDrawer = false;
export const isShowUnitDrawerItem = false;

//!Station wise config maintain new station by adding it into configs.
export const anthrosStations = [
  "101",
  "102",
  "103",
  "104",
  "105",
  "106",
  "107",
  "108",
];
export const shootingStations = [
  "301",
  "302",
  "303",
  "304",
  "305",
  "306",
  "307",
];

export const strengthAndAgilityStations = ["201", "202", "203", "204", "205"];
